export default "We can visualize this by overlaying shifted copies of the image. Each shift represents one neighboring position. Watch them cycle through.\n"